import styled from "styled-components";
export const ContentLoader = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
`;

export const ContentModalSurveyCategory = styled.div`
  position: absolute;
  left: 35.2%;
  right: 35.2%;
  top: 3.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;
  width: auto;
`;

export const CloseModalSurveyCategory = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TableViewButton = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 40px;
  height: 40px;
  .list-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.text.primary : theme.tabs.selected)};
  }
  .card-view {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const ActionSection = styled.div`
  display: grid;
  grid-template-columns: 270px 2fr;
  width: 96%;
  margin-left: 2%;
  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .table-action {
    margin-right: 0px;
  }
`;
export const SearchField = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  background: ${({ theme }) => theme.neutral.white};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  max-width: 190px;
  margin-right: 20px;
  svg {
    position: absolute;
  }
  input {
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
    margin-left: 2rem;
    padding-right: 1rem;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: #989898;
  }
`;
